import { render, staticRenderFns } from "./margin.vue?vue&type=template&id=7755be60&"
import script from "./margin.vue?vue&type=script&lang=js&"
export * from "./margin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports